"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioModule = void 0;
var inversify_1 = require("inversify");
var interfaces_1 = require("@dp-instant/interfaces");
var AudioModel_1 = require("./model/AudioModel");
var PlayMusicAction_1 = require("./actions/PlayMusicAction");
var PlaySoundAction_1 = require("./actions/PlaySoundAction");
var InitAudioAction_1 = require("./actions/InitAudioAction");
exports.AudioModule = new inversify_1.ContainerModule(function (bind) {
    bind(interfaces_1.TypesAudio.model).to(AudioModel_1.AudioModel).inSingletonScope();
    bind(interfaces_1.TypesAudio.initAction).to(InitAudioAction_1.InitAudioAction);
    bind(interfaces_1.TypesAudio.soundAction).to(PlaySoundAction_1.PlaySoundAction);
    bind(interfaces_1.TypesAudio.musicAction).to(PlayMusicAction_1.PlayMusicAction);
});
//# sourceMappingURL=AudioModule.js.map